import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { useClickToTextDetailsModalContext } from 'pages/clickToText/pages/all/context'
import styles from './styles.module.scss'

export const DetailsClickToTextHeader = observer(() => {
  const clickToText = useClickToTextDetailsModalContext()
  const { name } = clickToText
  return (
    <>
      <div className={styles.titleWrap}>
        <Typography
          tag={'div'}
          ariaLabel={'details.link.name'}
          variant={'heading-lg'}
          tooltipProps={{
            label: name,
          }}
          ellipsis
          className={styles.name}
        >
          {name}
        </Typography>
      </div>
    </>
  )
})
